import {Injectable} from '@angular/core';
import {Company} from './http/interfaces/company.interface';
import {CompaniesService} from './http/companies.service';
import {Observable} from 'rxjs';
import {CustomerInterface} from './newHttp/interfaces/customer.interface';
import {CustomerService} from './newHttp/customer.service';
import {NumberchipService} from './newHttp/numberchip.service';
import {NumberchipInterface} from './newHttp/interfaces/numberchip.interface';
import {AuthService} from './auth.service';
import {ApiUserService} from './newHttp/api-user.service';
import {id} from '@swimlane/ngx-datatable';
import {Products} from './newHttp/interfaces/products.interface';
import { ProductsService } from './newHttp/products.service';
import { ProjectService } from './newHttp/project.service';
import {ProjectInterface} from './newHttp/interfaces/project.interface';

@Injectable()
export class PrincipalService {
    /**
     * Companies list for filter
     */
    private companies: Company[] = [];

    /**
     * Customers list for filter
     */
    private customer: CustomerInterface[] = [];

    /**
      * Project list for filter
      */
    private projects: ProjectInterface[] = [];

    /**
     * Numberchips
     */
    private numberchips: string[] = [];

    private apiUserId: string;

    private products: Products[] = [];

    /**
     * Constructor
     * @param companiesService - Companies Service
     * @param customerService - Customer Service
     * @param numberchipService - Numberchip Service
     * @param authService - Authentication Service
     * @param userService - API User Service
     * @param productService - Products Service
     * @param projectService - Project Service
     */
    constructor(
        private companiesService: CompaniesService,
        private customerService: CustomerService,
        private numberchipService: NumberchipService,
        private authService: AuthService,
        private userService: ApiUserService,
        private productService: ProductsService,
        private projectService: ProjectService
    ) {
        this.getCompanies();
    }

    clearAll() {
        this.companies = [];
        this.customer = [];
        this.numberchips = [];
        this.products = [];
        this.projects = [];
    }

    /**
    * Sort projects by name
    */
    sortProjects(values: ProjectInterface[]): ProjectInterface[] {
        return values.sort((a, b) => {
            if (a.description > b.description) { return 1; }
            if (a.description < b.description) { return -1; }
            return 0;
        });
    }

    /**
     * Sort companies by name
     */
    sortCompanies(values: Company[]): Company[] {
        return values.sort((a, b) => {
            if (a.nome > b.nome) { return 1; }
            if (a.nome < b.nome) { return -1; }
            return 0;
        });
    }

    /**
     * Sort customer list
     */
    sortCustomers(values: CustomerInterface[]): CustomerInterface[] {
        return values.sort((a, b) => {
            if (a.description > b.description) { return 1; }
            if (a.description < b.description) { return -1; }
            return 0;
        });
    }

    /**
     * Sort numberchip list
     */
    sortNumberchips(values: string[]): string[] {
        return values.sort((a, b) => {
            if (a > b) { return 1; }
            if (a < b) { return -1; }
            return 0;
        });
    }

    /**
     * Sort products by name
     */
    sortProducts(values: Products[]): Products[] {
        return values.sort((a, b) => {
            if (a.name > b.name) { return 1; }
            if (a.name < b.name) { return -1; }
            return 0;
        });
    }

    /**
      * Return project by CustomarId
      */
    public getProjectsByCustomerId(id): Observable<ProjectInterface[]> {
        return new Observable<ProjectInterface[]>(observer => {
            this.projectService.getByCustomer(id).subscribe(result => {
                this.projects = this.sortProjects(result);
                observer.next(this.projects);
            });
        });
    }

    /**
      * Return project by customer Id and waba
      */
    public getProjectsByCustomerIdAndWaba(id, waba): Observable<ProjectInterface[]> {
        return new Observable<ProjectInterface[]>(observer => {
            this.projectService.getByCustomer(id, waba).subscribe(result => {
                this.projects = this.sortProjects(result);
                observer.next(this.projects);
            });
        });
    }

    /**
     * Return or update companies list
     */
    public getCompanies(): Observable<Company[]> {
        return new Observable<Company[]>(observer => {
            if (this.companies && this.companies.length === 0) {
                this.companiesService.getCompanies().subscribe(result => {
                    this.companies = this.sortCompanies(result.empresas);
                    observer.next(this.companies);
                });
            } else {
                observer.next(this.companies);
            }
        });
    }

    /**
     * Return or update companies list
     */
    public getNumberchips(userId?: string): Observable<string[]> {
        return new Observable<string[]>(observer => {
            if (userId) {
                this.userService.get(id).subscribe(result => {
                    observer.next(result.user.numberchips);
                });
            }
            // if (this.numberchips && this.numberchips.length === 0) {
                this.numberchipService.list(1, '', 100000).subscribe(result => {
                    const rows: NumberchipInterface[] = result[0]?.data;
                    this.numberchips = [];
                    rows.forEach(row => {
                        this.numberchips.push(row.numberchip);
                    })
                    this.numberchips = this.sortNumberchips(this.numberchips);
                    observer.next(this.numberchips);
                });
            // } else {
            //     observer.next(this.numberchips);
            // }
        });
    }

    /**
     * Return or update companies list
     */
    public getCustomers(): Observable<CustomerInterface[]> {
        return new Observable<CustomerInterface[]>(observer => {
            // if (this.customer && this.customer.length === 0) {
                this.customerService.list(1, '', 9000).subscribe(result => {
                    this.customer = this.sortCustomers(result[0].data);
                    observer.next(this.customer);
                });
            // } else {
            //     observer.next(this.customer);
            // }
        });
    }

    /**
     * Return or update companies list
     */
    public getProducts(): Observable<Products[]> {
        return new Observable<Products[]>(observer => {
            this.productService.list().subscribe(result => {
                this.products = this.sortProducts(result.products);
                observer.next(this.products);
            });
        });
    }

    /**
     * Return customer by Id
     */
    public findCustomerById(id): CustomerInterface {
        const customer = this.customer.filter(p => p._id === id);
        return !!customer[0] ? customer[0] : null;
    }

    setApiUserId(value: string) {
        this.apiUserId = value;
    }
}
